// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Avatar, Group, Skeleton, Stack, Text, useMantineTheme } from '@mantine/core';
import { useContactDetails } from '../../../Service/Context/ContactDetailsContext';
import { ThemeText } from '../../../Atoms/ThemeText';
import { isDefined } from '../../../Service/ValidationS';
import { printify } from '../../../Utils/utils';

const ContactTile = () => {
  const { contact, loading } = useContactDetails();
  const theme = useMantineTheme();
  const { firstName, lastName, email, companyName, contactType } = contact ?? {};

  if (loading) {
    return <Skeleton height={50} width="100%" />;
  }
  if (!contact) return null;

  const getLetters = () => {
    if (firstName && lastName) {
      return `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`;
    }
    if (firstName) return firstName[0].toUpperCase();
    if (lastName) return lastName[0].toUpperCase();
    if (companyName) return companyName.toUpperCase();
    if (email) return email[0].toUpperCase();
    return ':)';
  };

  return (
    <Group>
      {/* <Avatar color={theme.colorScheme === 'light' ? 'dark' : 'gray'} radius="xl">
        {getLetters()}
      </Avatar> */}
      <Stack spacing={0}>
        {contactType === 'COMPANY' && isDefined(companyName) && <ThemeText>{companyName}</ThemeText>}
        {contactType !== 'COMPANY' && <ThemeText>{`${printify(firstName)} ${printify(lastName)}`}</ThemeText>}
        <Text size="xs" color="dimmed">
          {email}
        </Text>
      </Stack>
    </Group>
  );
};

export default ContactTile;
